import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionMembresia";
import MembresiaPlantilla, {
  MembresiaMeta
} from "../../../../types/MembresiaPlantilla";
import {
  GetComisionMembresiaPlantilla,
  PostComisionMembresiaPlantilla,
  PostComisionMembresiaPlantillaConfirmar,
  DeleteComisionMembresiaPlantilla,
  PutRegionMetas,
  PutClubMetas,
  PutAsesoresMetas
} from "../../../reducers/comisionMembresia";

export interface ConfiguracionPlantillaDispatcher {
  getPlantillaByPeriodo: (
    periodo: string
  ) => Promise<Preview<GetComisionMembresiaPlantilla>>;
  postPlantilla: (
    plantilla: MembresiaPlantilla
  ) => Promise<Preview<PostComisionMembresiaPlantilla>>;
  confirmarPlantilla: (
    id: number
  ) => Promise<Preview<PostComisionMembresiaPlantillaConfirmar>>;
  deletePlantillaByPeriodo: (
    periodo: string
  ) => Promise<Preview<DeleteComisionMembresiaPlantilla>>;
  putRegionMetas: (
    idRegion: number,
    metas: MembresiaMeta
  ) => Promise<Preview<PutRegionMetas>>;
  putClubMetas: (
    idLider: number,
    metas: MembresiaMeta
  ) => Promise<Preview<PutClubMetas>>;
  putAsesoresMetas: (
    idLider: number,
    metas: MembresiaMeta
  ) => Promise<Preview<PutAsesoresMetas>>;
}

export const configuracionPlantillaDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ConfiguracionPlantillaDispatcher = dispatch => ({
  getPlantillaByPeriodo: (periodo: string) => {
    return dispatch(actions.getPlantillaByPeriodo(periodo));
  },
  postPlantilla: (plantilla: MembresiaPlantilla) => {
    return dispatch(actions.postPlantilla(plantilla));
  },
  confirmarPlantilla: (id: number) => {
    return dispatch(actions.confirmarPlantilla(id));
  },
  deletePlantillaByPeriodo: (periodo: string) => {
    return dispatch(actions.deletePlantillaByPeriodo(periodo));
  },
  putRegionMetas: (idRegion: number, metas: MembresiaMeta) => {
    return dispatch(actions.putRegionMetas(idRegion, metas));
  },
  putClubMetas: (idLider: number, metas: MembresiaMeta) => {
    return dispatch(actions.putClubMetas(idLider, metas));
  },
  putAsesoresMetas: (idLider: number, metas: MembresiaMeta) => {
    return dispatch(actions.putAsesoresMetas(idLider, metas));
  }
});
